import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '@/components/Button';

import { Container, Title, Info } from './styles';

const NewPasswordFailure: React.FC = () => {
  const history = useHistory();

  return (
    <Container>
      <Title>Ops! Parece que este link expirou</Title>
      <Info>
        Na tela de login, tente redefinir a senha novamente para receberl um
        link válido em seu e-mail.
      </Info>

      <Button onClick={() => history.push('/entrar')} theme="secondary">
        Entrar no Medflow
      </Button>
    </Container>
  );
};

export default NewPasswordFailure;
